/* eslint-disable comma-dangle */
export function updateProfileRequest(
  firstName,
  lastName,
  email,
  city,
  state,
  password,
  id
) {
  return {
    type: '@user/UPDATE_PROFILE_REQUEST',
    payload: {
      firstName,
      lastName,
      email,
      city,
      state,
      password,
      id,
    },
  };
}

export function updateProfileSuccess(profile) {
  return {
    type: '@user/UPDATE_PROFILE_SUCCESS',
    payload: { profile },
  };
}

export function updateProfileFailure() {
  return {
    type: '@user/UPDATE_PROFILE_FAILURE',
  };
}

export function notShowChallengeVideoRequest(status) {
  return {
    type: '@user/NOT_SHOW_CHALLENGE_VIDEO_REQUEST',
    payload: { status },
  };
}

export function notShowChallengeVideoSuccess(profile) {
  return {
    type: '@user/NOT_SHOW_CHALLENGE_VIDEO_SUCCESS',
    payload: { profile },
  };
}

export function notShowChallengeVideoFailure() {
  return {
    type: '@user/NOT_SHOW_CHALLENGE_VIDEO_FAILURE',
  };
}
